export default __webpack_public_path__ + "static/450-e33e104b9118faac64d927c691f51d83.jpg";